import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import SectionDivider from "./SectionDivider";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_garnacha-nordic/artifacts/548npw6z_Sin%20t%C3%ADtulo%20%284500%20x%205100%20px%29.svg";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="bg-[#0F0F10] text-[#FFF8F0]">
      <div className="container-pad py-28 sm:py-36">
        {/* Hero logo moment */}
        <div className="flex justify-center mb-10" data-testid="footer-logo-hero">
          <img
            src={LOGO_URL}
            alt="GARNACHA Mexican Street Food"
            className="h-48 sm:h-64 lg:h-80 w-auto object-contain"
            data-testid="footer-logo"
          />
        </div>

        <SectionDivider variant="papel" tone="dark" className="mb-20" data-testid="footer-divider" />

        <div className="border-t border-white/10 pt-16 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <p className="text-base text-[#FFF8F0]/60 max-w-md leading-relaxed">{t.footer.madeIn}</p>
          </div>
          <div className="lg:col-span-3">
            <div className="eyebrow text-[#FFF8F0]/40 mb-6">{t.footer.links}</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" data-testid="footer-home" className="hover:text-[#F97316] transition-colors">{t.nav.home}</Link></li>
              <li><Link to="/products" data-testid="footer-products" className="hover:text-[#F97316] transition-colors">{t.nav.products}</Link></li>
              <li><Link to="/our-history" data-testid="footer-about" className="hover:text-[#F97316] transition-colors">{t.nav.about}</Link></li>
              <li><Link to="/b2b" data-testid="footer-b2b" className="hover:text-[#F97316] transition-colors">{t.nav.b2b}</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="hover:text-[#F97316] transition-colors">{t.nav.contact}</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <div className="eyebrow text-[#FFF8F0]/40 mb-6">{t.footer.social}</div>
            <ul className="space-y-3 text-sm">
              <li><a href="https://instagram.com/thisisgarnacha" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="hover:text-[#F97316] transition-colors">Instagram</a></li>
              <li><a href="https://facebook.com/thisisgarnacha" target="_blank" rel="noopener noreferrer" data-testid="social-facebook" className="hover:text-[#F97316] transition-colors">Facebook</a></li>
              <li><a href="https://tiktok.com/@thisisgarnacha" target="_blank" rel="noopener noreferrer" data-testid="social-tiktok" className="hover:text-[#F97316] transition-colors">TikTok</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-[#FFF8F0]/40">
          <span>{t.footer.legal}</span>
          <span className="tracking-[0.3em] uppercase">Helsinki · Finland</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
